import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { ButtonController, IButtonControllerOptions } from '../../../Common/ButtonController';
import { LocalizationContents } from '../../../LocalizationContents';
import { GameLogic } from '../../../Logic/GameLogic';
import { GameModel } from '../../../Models/GameModel';
import { GreenButtonStrokeTextStyle, YellowButtonStrokeTextStyle } from '../../../Constants/TextStyles';
import { DevConfig } from '../../../Common/DevConfig';

export interface ICatalogListControllerOptions {
    onClick: (albumId: string) => void;
}

export class CatalogListController extends AnimationBaseController {
    $model: GameModel;

    private buttons: ButtonController[] = [];

    public constructor(
        @Inject private _options: ICatalogListControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('CatalogListController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
            }
        };
    }

    protected onInitialize() {
        this.getDisplayObjectByQuery('arrow_slider')[0].visible = false;
        this.getDisplayObjectByQuery('btn_gloria')[0].visible = false;
        this.getDisplayObjectByQuery('btn_collection')[0].visible = false;

        let nextY = this.getDisplayObjectByQuery('btn_gloria')[0].y;
        let nextX = this.getDisplayObjectByQuery('btn_gloria')[0].x;
        const arr = this.$model.albumLibrary.getAllAlbums();

        if (!DevConfig.HIDE_ALBUM_GLORIA) {
            const album = arr[0];
            this.addChildController({
                controller: ButtonController,
                animationContent: AnimationContents.CATALOG_JSON,
                libraryName: 'btn_gloria',
                options: <IButtonControllerOptions>{
                    label: LocalizationContents.getText(album.title),
                    style: YellowButtonStrokeTextStyle,
                    onClick: (status: boolean) => {
                        this._options.onClick(album.id);
                    },
                },
            }, album.id);
            const button = this.$childControllers.get(album.id) as ButtonController;
            button.gotoAndStop('active');
            button.display.x = nextX;
            button.display.y = nextY;
            this.buttons.push(button);

            nextY += 120;
        }

        for (let i = 1; i < arr.length; i++) {
            const album = arr[i];
            this.addChildController({
                controller: ButtonController,
                animationContent: AnimationContents.CATALOG_JSON,
                libraryName: 'btn_collection',
                options: <IButtonControllerOptions>{
                    label: LocalizationContents.getText(album.title),
                    style: GreenButtonStrokeTextStyle,
                    onClick: (status: boolean) => {
                        this._options.onClick(album.id);
                    },
                },
            }, album.id);
            const button = this.$childControllers.get(album.id) as ButtonController;
            button.gotoAndStop('active');
            button.display.x = nextX;
            button.display.y = nextY;

            nextY += 120;
        }

        // this.selectAlbum('my_collection')
    }

    public selectAlbum(id: string | undefined): void {
        const arr = this.$model.albumLibrary.getAllAlbums();
        for (let i = 0; i < arr.length; i++) {
            const album = arr[i];
            const button = this.$childControllers.get(album.id) as ButtonController;
            if (!button) {
                continue;
            }

            button.toggle = album.id === id;
        }
    }

}
